module.exports = __webpack_public_path__ + "img/logo-3.880db1ea.png";